import { Controller } from 'react-hook-form';
import { useKlavioEmailSubscription } from 'shared/hooks/useKlavioEmailSubscription';
import styles from '../FooterConnect/styles.module.scss';
import { useFooterContext } from '../FooterContext';
import FooterInput from '../FooterInput/FooterInput';

export const FooterConnectForm = ({ title }: { title?: string }) => {
  const {
    data: {
      subscribeForm: { placeholder, buttonLabel, successMessage, errorMessage }
    }
  } = useFooterContext();

  const { isPending, control, handleFormSubmit, isSuccess, errors } = useKlavioEmailSubscription({
    location: 'footer',
    errorMessage,
    eventTitleProp: title
  });

  return (
    <form className={styles.form} onSubmit={handleFormSubmit}>
      <Controller
        control={control}
        name="email"
        render={({ field }) => (
          <FooterInput
            {...field}
            placeholder={placeholder || ''}
            buttonLabel={buttonLabel}
            successMessage={successMessage}
            isLoading={isPending}
            errors={errors}
            isSuccess={isSuccess}
          />
        )}
      />
    </form>
  );
};
